import { request, RequestInitWithRetry } from "../../lib/request";

export type DeviceWifiSignalLevelData = {
  date: number,
  local: number | null,
  level: number | null,
  rssi: number | null,
  ssid: string | null,
  bssid: string | null,
  frequency: string | null,
  status: string | null
};

export type DeviceWifiSignalLevel = DeviceWifiSignalLevelData[];

export type DeviceWifiSignalStrengthParams = {
  deviceId: string,
  to: number
};

export type ExportDeviceWifiSignalStrengthParams = {
  deviceId: string,
  to: number
};

export function getDeviceWifiSignalStrength(params: DeviceWifiSignalStrengthParams) {
  return async (options: RequestInitWithRetry): Promise<DeviceWifiSignalLevel> => {
    const input = {
      path: `/api/core/device/wifiSignalStrength`,
      qs: { deviceId: params.deviceId },
      body: {
        to: params.to
      }
    };
    return request(input, options);
  };
}

export function exportDeviceWifiSignalStrength(requestOptions: RequestInitWithRetry) {
  return async (options: ExportDeviceWifiSignalStrengthParams): Promise<string> => {
    const input = {
      path: `/api/core/device/exportWifiSignalStrength`,
      body: {
        to: options.to,
        deviceId: options.deviceId
      },
      method: 'post'
    };
    return request(input, requestOptions);
  };
}
